module.exports = "/assets/data/c94c5aff8c8fb5d4312b69beb8f30bb4-SK23.data.json";